"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeXML = exports.FRAGMENT_TAG = exports.TEXT_TAG = exports.TRUSTED_TEXT_TAG = void 0;
exports.normaliseNodes = normaliseNodes;
var escape_xml_1 = require("./escape.xml");
var export_string_1 = require("./export.string");
exports.TRUSTED_TEXT_TAG = '<';
exports.TEXT_TAG = '#';
exports.FRAGMENT_TAG = '[';
function normaliseNodes(children) {
    if (Array.isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (typeof child === 'string') {
                children[i] = exports.IkeXML.text(child);
            }
        }
    }
    return children;
}
var EMPTY_ATTRS = Object.freeze({});
var EMPTY_ARRAY = Object.freeze([]);
function n(tag, attrs, children) {
    var actualAttrs;
    var actualChildren;
    if (exports.IkeXML.isVNodeChildren(attrs)) {
        actualChildren = normaliseNodes(attrs);
    }
    else if (exports.IkeXML.isNode(attrs)) {
        actualChildren = [attrs];
    }
    else if (exports.IkeXML.isVNodeAttrs(attrs)) {
        actualAttrs = attrs;
    }
    else if (typeof attrs === 'string') {
        actualChildren = [exports.IkeXML.text(attrs)];
    }
    // If a child was passed in was it wrapped in a array or not?
    if (children != null) {
        if (exports.IkeXML.isNode(children)) {
            actualChildren = [children];
        }
        else if (typeof children === 'string') {
            actualChildren = [exports.IkeXML.text(children)];
        }
        else {
            actualChildren = normaliseNodes(children);
        }
    }
    return {
        tag: tag,
        attrs: actualAttrs || {},
        children: actualChildren || []
    };
}
var isVNodeChildren = function (k) { return Array.isArray(k); };
var isVNodeAttrs = function (k) { return typeof k === 'object'; };
exports.IkeXML = {
    Escape: escape_xml_1.Escape,
    Export: {
        asString: export_string_1.exportVNodeToString
    },
    EMPTY_ATTRS: EMPTY_ATTRS,
    EMPTY_ARRAY: EMPTY_ARRAY,
    n: n,
    isVNodeChildren: isVNodeChildren,
    isVNodeAttrs: isVNodeAttrs,
    text: function (text) {
        return {
            tag: exports.TEXT_TAG,
            attrs: EMPTY_ATTRS,
            children: EMPTY_ARRAY,
            text: text
        };
    },
    trust: function (text) {
        return {
            tag: exports.TRUSTED_TEXT_TAG,
            attrs: EMPTY_ATTRS,
            children: EMPTY_ARRAY,
            text: text
        };
    },
    fragment: function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        return {
            tag: exports.FRAGMENT_TAG,
            attrs: EMPTY_ATTRS,
            children: nodes
        };
    },
    isNode: function (node) {
        return node != null && node.tag != null;
    },
    isTrustedTextNode: function (node) {
        return node != null && node.tag === exports.TRUSTED_TEXT_TAG;
    },
    isTextNode: function (node) {
        return node != null && node.tag === exports.TEXT_TAG;
    },
    isFragmentNode: function (node) {
        return node != null && node.tag === exports.FRAGMENT_TAG;
    }
};
//# sourceMappingURL=index.js.map